export class TypeHelper {
    // Returns if a value is a string
    public static isString(value: any) {
        return typeof value === 'string' || value instanceof String;
    }

    public static isNumber(value: any) {
        return typeof value === 'number' && isFinite(value);
    }

    public static isDate(value: any) {
        return value instanceof Date;
    }

    public static isBoolean(value: any) {
        return typeof value === 'boolean';
    }

    public static isNull(value: any) {
        return value === null;
    }

    // Returns if a value is undefined
    public static isUndefined(value: any) {
        return typeof value === 'undefined';
    }

    public static isNullOrUndefined(value: any) {
        return TypeHelper.isNull(value) || TypeHelper.isUndefined(value);
    }

    public static isNullOrUndefinedOrZero(value: any) {
        return TypeHelper.isNullOrUndefined(value) || value === 0;
    }

    public static isObject(value: any) {
        return value && typeof value === 'object' && value.constructor === Object;
    }

    public static isArray(value: any) {
        return Array.isArray(value);
    }

    public static toNumber(val: any) {
        if (TypeHelper.isNumber(val)) {
            return val;
        }
        const intVal = parseInt(val.toString());

        return intVal;
    }

    public static toInteger(val: string) {
        if (!TypeHelper.isNullOrUndefined(val) && TypeHelper.stringIsInteger(val)) {
            return parseInt(val.toString());
        }

        return NaN;
    }

    public static stringIsInteger(val: string) {
        const regex = /^\d+$/;
        const regexp = new RegExp(regex);
        return regexp.test(val);
    }

    public static isValidIntegerInRange = (value: any, lowerLimit: number = 0, upperLimit: number = 59) => {
        const intValue = TypeHelper.toInteger(value);
        if (!isNaN(value) && intValue >= lowerLimit && intValue <= upperLimit) {
            return true;
        };
        return false;
    }

    public static isNonZeroNumber = (value: any): boolean => {
        if (!TypeHelper.isNullOrUndefined(value) && TypeHelper.isNumber(value)) {
            return value > 0;
        }
        return false;
    }

    public static isEmptyNullorUndefined(value: any) {
        return this.isNullOrUndefined(value) || value === '';
    }

    public static isFunction(functionToCheck: any) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    }

    public static ValueOrDefault<T>(val: T, defaultVal: T) {
        if (val === null || val === undefined) {
            return defaultVal;
        }

        return val;
    }
}